import styles from './areaAssignments.module.css';
import Card from '../../../components/Card/Card';
import PersonSelection from '../../ToolComponents/PersonSelection/PersonSelection';
function AreaAssignments({
    contacts,
    assignments,
    areaSettings,
    onAddContact,
    onRemoveContact,
    onUpdatePosition,
    onUpdateAufgabe,
    onToggleEmail,
    onTogglePhone
}) {
    return (
        <div className={styles.listContainer}>
            <h2 className={styles.sectionHeader}>Zuordnung von Kontakten</h2>
            {Object.keys(areaSettings).map(area => {
                const areaInfo = areaSettings[area];
                const assignedContacts = assignments[area] || [];
                const disableSelect = !areaInfo.allowMultiple && assignedContacts.length >= 1;

                return (
                    <Card key={area} title={area}>
                        <div className={styles.areaBlock}>
                            <PersonSelection
                                persons={assignedContacts}
                                allPersons={contacts}
                                disableSelect={disableSelect}
                                onAddPerson={(person) => onAddContact(area, person)}
                                onRemovePerson={(id) => onRemoveContact(area, id)}
                                onUpdatePosition={(id, val) => onUpdatePosition(area, id, val)}
                                onUpdateTask={(id, val) => onUpdateAufgabe(area, id, val)}
                                onToggleEmail={(id) => onToggleEmail(area, id)}
                                onTogglePhone={(id) => onTogglePhone(area, id)}
                            />
                        </div>
                    </Card>
                );
            })}
        </div>
    );
}

export default AreaAssignments;
